var React = require('react');

function Xreal (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1 2H9.35L15.7 13.81H16.31L22.7 2H31.06L21.35 18.24L31.06 34.67H22.7L16.31 22.67H15.7L9.35 34.67H1L10.61 18.24L1 2ZM36 2H50.89C58.07 2 61.34 6.76 61.34 12.45C61.34 16.28 59.89 20.45 55.74 22.07L62.23 34.67H54.15L48.46 22.77H43.19V34.67H36V2ZM49.63 17.12C52.19 17.12 54.11 15.63 54.11 12.5C54.11 9.75 52.57 7.93 49.49 7.93H43.19V17.12H49.63ZM89.87 2H67.87V34.67H89.94V28.74H75.1V20.81H87.56V15.16H75.1V7.93H89.87V2ZM114 2L125.16 34.67H117.22L114.8 26.55H103.94L101.51 34.67H93.58L104.78 2H114ZM113.12 20.9L109.59 9.05H109.21L105.67 20.9H113.12ZM137 2H129.75V34.67H149.09V28.74H137V2Z","fill":"black"}));
}

Xreal.defaultProps = {"width":"150","height":"36","viewBox":"0 0 150 36","fill":"none"};

module.exports = Xreal;

Xreal.default = Xreal;
